type ClassValue = string | false | null | undefined | Record<string, boolean>;

/**
 * Combines class names, filtering out falsy values and expanding object keys where the value is true.
 * This is a stripped down version of the `classnames` package, but without support for arrays or number values.
 *
 * @example
 * cx('foo', 'bar')                             // 'foo bar'
 * cx('foo', false, null, undefined)            // 'foo'
 * cx('btn', { active: true, disabled: false }) // 'btn active'
 */
export function cx(...args: ClassValue[]): string {
  const classes: string[] = [];
  for (const arg of args) {
    if (!arg) continue;
    if (typeof arg === 'string') {
      classes.push(arg);
    } else {
      for (const [key, val] of Object.entries(arg)) {
        if (val) classes.push(key);
      }
    }
  }
  return classes.join(' ');
}
